/* eslint-disable yoda */
import React, { useState, useCallback } from 'react';

import { Dialog, DialogContent } from '@ps-design-system/components/Dialog';

import UploaderMediaOptions from './UploaderMediaOptions';
import UploaderAdd3DTour from './UploaderAdd3DTour';
import UploaderAddVideo from './UploaderAddVideo';

import { useUploadModal } from '../context/UploadModalContext';
import { useUploaderActions } from '../hooks/useUploaderActions';

const UploaderMediaModal = () => {
  const [currentStep, setCurrentStep] = useState('choose-media');
  const [newlyAddedMedia, setNewlyAddedMedia] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const { openMedia, setMediaOpen, closeMediaModal } = useUploadModal();
  const { handleEmbedUpload, handleDelete } = useUploaderActions();

  const handleAddMedia = async (link) => {
    setIsAdding(true);
    try {
      const newMediaItems = await handleEmbedUpload(link);

      if (newMediaItems && Array.isArray(newMediaItems) && newMediaItems.length > 0) {
        const lastItem = newMediaItems[newMediaItems.length - 1];
        setNewlyAddedMedia(prevMedia => [...prevMedia, lastItem]);
      }
    } catch (error) {
      // silently fail
    } finally {
      setIsAdding(false);
    }
  };

  const handleDeleteMedia = useCallback((mediaItem) => {
    setNewlyAddedMedia(prevMedia => prevMedia.filter(item => item.id !== mediaItem.id));
    handleDelete(mediaItem);
  }, [handleDelete]);

  const handleStep = (nextStep) => {
    setCurrentStep(nextStep);
  };

  const handleBack = () => {
    handleStep('choose-media');
    setNewlyAddedMedia([]);
  };

  const handleDone = () => {
    handleStep('choose-media');
    setNewlyAddedMedia([]);
    closeMediaModal();
  };

  const handleOpenChange = (isOpen) => {
    setMediaOpen(isOpen);

    if (!isOpen) {
      setCurrentStep('choose-media');
      setNewlyAddedMedia([]);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
    case 'choose-media':
      return <UploaderMediaOptions onNext={handleStep} />;
    case 'add-videos':
      return (
        <UploaderAddVideo
          media={newlyAddedMedia}
          onAdd={handleAddMedia}
          onDelete={handleDeleteMedia}
          onDone={handleDone}
          onBack={handleBack}
          isAdding={isAdding}
        />
      );
    case 'add-3d-tour':
      return (
        <UploaderAdd3DTour
          media={newlyAddedMedia}
          onAdd={handleAddMedia}
          onDelete={handleDeleteMedia}
          onDone={handleDone}
          onBack={handleBack}
          isAdding={isAdding}
        />
      );
    default:
      return null;
    }
  };

  return (
    <Dialog open={openMedia} onOpenChange={handleOpenChange} >
      <DialogContent
        size="lg"
        className="uploader-dialog-content"
      >
        {renderStep()}
      </DialogContent>
    </Dialog>
  );
};

export default UploaderMediaModal;
